/**
 * Created by Allan on 2022/03/01.
 * Contact 84880528@qq.com.
 * 获取URL上面的token和appid参数
 */
const getQueryString = function (str, variable) {
    var query = str.split("?")[1];
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return false;
};

export default getQueryString



// WEBPACK FOOTER //
// ./src/config/getQueryString.js